import React from "react";
import CrcExceptionList from "@/pages/onlineOperations/crcExceptionList/crcExceptionList";
import OrderInfoPage from "@/pages/configurationManagement/stub/orderInfoPage";
import UnDirectConnectOrder from "@/pages/configurationManagement/stub/UnDirectConnectOrder";
// 1.7.0新增
// import DisChargeOrder from "@/pages/configurationManagement/stub/dischargeOrder";
// 1.3.0新增部分
import ModuleList from "@/pages/configurationManagement/module/moduleList";
import EventMonitoring from "@/pages/exceptionManagement/eventMonitoring/eventMonitoring";
import FaultReportingList from "@/pages/exceptionManagement/faultReporting/faultReportingList";
import PowerFaultReportingList from "@/pages/exceptionManagement/powerFaultReporting/powerFaultReportingList";
import ModuleDetail from "@/pages/configurationManagement/module/moduleDetail";
import ModuleInfo from "@/pages/configurationManagement/module/moduleInfo";
// 1.4.0 新增部分
import IndicatorDateDownload from "@/pages/onlineOperations/IndicatorDataDownload/indicatorDateDownload";
import ElectricalLoss from "@/pages/indicatorReport/electricalLoss/electricalLoss";
import StubStationIntact from "@/pages/indicatorReport/stubIntactRate/stubStationIntact";
import ChargeCourse from "@/pages/configurationManagement/stub/orderStubCourse";
import PowerCourse from "@/pages/configurationManagement/stub/orderPowerCourse";
import StubIntactDetail from "@/pages/indicatorReport/stubIntactRate/stuIntactDetail";
// 1.4.1 新增部分
import MonitoringDetail from "@/pages/exceptionManagement/eventMonitoring/monitoringDetail";
// 1.5.1 新增部分
import OprationLog from "@/pages/oprationLog/oprationLog";
import DisplayBoardIndex from "@/pages/displayBoard/displayBoardIndex";

import CityRankTotal from "@/pages/displayBoard/cityRankTotal";

import TicketCountPage from "@/pages/displayBoard/ticketCountPage";

import PeopleTicketWorkCount from "@/pages/displayBoard/peopleTicketWorkCount";
import ErrorPlat from "@/pages/displayBoard/errorPlat";
import DeviceWatchPlat from "@/pages/displayBoard/deviceWatchPlat";

import StateUnusualList from "@/pages/onlineOperations/stateUnusual/stateUnusualList";
// 1.6.0新增部分
import ErrorCodeManage from "@/pages/system/errorCodeManage";
import TMaterialsTypeManage from "@/pages/system/tMaterialsTypeManage";

import UseManagement from "@/pages/system/useManagement";
import DownloadCenter from "@/pages/system/downloadCenter";
import ErrorCodeConfig from "@/pages/system/errorCodeManage/errorCodeConfig";
import TMaterialsTypeConfig from "@/pages/system/tMaterialsTypeManage/tMaterialsTypeConfig";

import EquChargeDetail from "@/pages/indicatorReport/chargeSuccessRate/equChargeDetail";
import StationChargeDetail from "@/pages/indicatorReport/chargeSuccessRate/stationChargeDetail";
import DiagnosticAnalysis from "@/pages/diagnosticManage/diagnosticAnalysis/index";
// 1.6.1新增部分
import FirmwareVersion from "@/pages/system/firmwareVersionManage/index";
import FirmwareVersionList from "@/pages/system/firmwareVersionManage/detailList";
// 1.6.2新增部分
import StubBasicInfo from "@/pages/configurationManagement/stub/stubBasicInfo";
import StubGroupBasicInfo from "@/pages/configurationManagement/stub/stubGroupBasicInfo";
import TaskBuildStep from "@/pages/onlineOperations/taskManagement/taskBuildStep";
// 1.7.0 新增部分
import StubGroupTobu from "@/pages/configurationManagement/stubGroup/stubGroupTobu";
import PermissionList from "../pages/system/permissions/permissionList";

import WareSourceStubList from "../pages/configurationManagement/stub/waresourceStubList";
import LookDevicePriceM from "../pages/configurationManagement/stub/lookDevicePriceM";

import TenceCompanyM from "../pages/configurationManagement/stub/tenceCompanyM";
import CityTypeCrud from "../pages/configurationManagement/stub/cityTypeCrud";
import EndCodeStatus from "../pages/configurationManagement/stub/endCodeStatus";

import StubOpLogInfo from "../pages/configurationManagement/stub/stubOpLogInfo";

import HpcLogDownLogInfo from "../pages/configurationManagement/stub/hpcLogDownLogInfo";
import WatchExcManage from "../pages/configurationManagement/stub/watchExcManage";

import StubList from "../pages/configurationManagement/stub/stubList";
import UnDirectConnectDevice from "../pages/configurationManagement/stub/UnDirectConnectDevice";
import LockList from "../pages/configurationManagement/stub/lockList";
import MoveEquipmentList from "../pages/configurationManagement/stub/moveEquipmentList";
import StubGroupList from "../pages/configurationManagement/stubGroup/stubGroupList";
import PowerBoxList from "../pages/configurationManagement/powerBox/powerBoxList";
import ChargSuccess from "../pages/indicatorReport/chargeSuccessRate/chargeSuccess";
import TicketPlat from "../pages/indicatorReport/chargeSuccessRate/ticketPlat";
import OrderDisplayBoard from "../pages/indicatorReport/chargeSuccessRate/orderDisplayBoard";
import LockStatistics from "@/pages/displayBoard/lockStatistics";
import InspectionAndMaintenanceStatistics from "@/pages/displayBoard/inspectionAndMaintenanceStatistics";

import StubIntact from "../pages/indicatorReport/stubIntactRate/stubIntact";
// import Account from "../pages/system/account/account";
import { cookieManager } from "../utils/cookieStorage";
import { sessionManager } from "../utils/sessionStorage";

class Tabs {
  constructor(addTab, remove) {
    return this.init(addTab, remove);
  }

  /**
   * 菜单初始化，根据id指定菜单
   * @param addTab
   * @returns {{}}
   */
  init(addTab, remove) {
    // 微前端子应用基础数据配置
    const microApps = [
      {
        name: "omc",
        // entry: "//localhost:3920/",
        // entry: 'http://localhost:8000',
        entry: process.env.REACT_APP_SAAS_OMC,
        container: "#microapp_omc",
        extraCls: "no-padding no-background",
      },
    ];

    /**
     * 根据appName添加对应参数
     * @param {*} appName 子应用app信息
     * @param {*} initKey 子应用初始化key(可选)
     */
    function bindAppParams(appName, initKey) {
      // 将国际化,用户信息传递到子应用
      const lang = sessionManager.getLasting("locale");
      const authJWT =
        cookieManager.get(`jwtToken_${sessionStorage.getItem("userName")}`) ||
        localStorage.getItem(`jwtToken_${sessionStorage.getItem("userName")}`);
      const userInfo = {
        token: sessionStorage.getItem("token"),
        name: sessionStorage.getItem("name"),
        id: sessionStorage.getItem("userId"),
        userAccount: sessionStorage.getItem("userAccount"),
        role: sessionStorage.getItem("role"),
        xxFlag: sessionStorage.getItem("xxFlag"),
      };
      return {
        ...(microApps.find((app) => appName === app.name) || {}),
        initKey,
        mainAppName: "omc",
        mainAppInfo: {
          lang,
          authJWT,
          userInfo,
        },
      };
    }

    const Frame = {
      "0001": <DisplayBoardIndex onAdd={addTab} />, // 电站运行看板--运行看板
      "0002": <DeviceWatchPlat onAdd={addTab} />, // 电站运行看板-设备数据
      "0003": <OrderDisplayBoard onAdd={addTab} />, // 电站运行看板-订单数据
      "0004": <TicketPlat onAdd={addTab} />, // 电站运行看板-工单数据
      "0005": <ErrorPlat onAdd={addTab} />, // 电站运行看板-故障
      "0302": <TicketCountPage onAdd={addTab} />, // 工单报表
      "0303": <PeopleTicketWorkCount onAdd={addTab} />, // 报表管理--人效指标
      "0304": <CityRankTotal onAdd={addTab} />, // 城市评分
      "0305": <LockStatistics onAdd={addTab} />, // 地锁统计
      "0306": <InspectionAndMaintenanceStatistics onAdd={addTab} />, // 巡检保养统计
      "0101": <StubGroupList onAdd={addTab} />, // 配置管理--电站列表
      "0102": <StubList onAdd={addTab} />, // 配置管理--设备快速查询
      "0108": <UnDirectConnectDevice onAdd={addTab} />, // 配置管理--非直连设备列表
      "0107": <LockList onAdd={addTab} />, // 配置信息--地锁查询
      "0109": <MoveEquipmentList onAdd={addTab} />, // 配置信息--挪桩设备查询
      9015: <LookDevicePriceM onAdd={addTab} />, // 巡检费用配置
      9013: <WatchExcManage onAdd={addTab} />, // 系统管理--监控事件配置
      "0103": <WareSourceStubList onAdd={addTab} />, // 配置信息--仓库设备查询
      "0104": <PowerBoxList onAdd={addTab} />, // 配置信息--配电柜管理
      "0105": <ModuleList onAdd={addTab} />, // 配置信息--模块管理
      "0501": <OrderInfoPage onAdd={addTab} />, // 配置管理--设备快速查询--订单信息；在线运维--订单列表
      "0509": <UnDirectConnectOrder onAdd={addTab} />, // 在线运维--非直连订单列表
      // "0510": <DisChargeOrder onAdd={addTab} />, // 在线运维--放电订单列表
      "0502": <OprationLog onAdd={addTab} />, // 在线运维--桩连平台日志
      "0106": <StubOpLogInfo onAdd={addTab} />, // 配置管理--维修记录
      "098923": <HpcLogDownLogInfo onAdd={addTab} />, // hpc设备日志下载记录
      "0504": <CrcExceptionList onAdd={addTab} />, // crc异常列表
      "0505": <IndicatorDateDownload onAdd={addTab} />, // 在线运维--指标数据下载
      "030101": <StubIntact onAdd={addTab} />, // 设备完好率
      "030102": <ChargSuccess onAdd={addTab} />, // 充电成功率
      "030103": <ElectricalLoss onAdd={addTab} />, // 电损
      "0401": <FaultReportingList onAdd={addTab} />, // 异常管理--故障上报列表
      "0405": <PowerFaultReportingList onAdd={addTab} />, // 异常管理--配电柜故障上报列表
      "0402": <EventMonitoring onAdd={addTab} />, // 异常管理--平台事件监控列表
      "0403": <StateUnusualList onAdd={addTab} />, // 状态异常列表
      // 9001: <Account onAdd={addTab} />, // 账户管理
      900301: <PermissionList onAdd={addTab} />, // 权限管理
      9004: <ErrorCodeManage onAdd={addTab} />, // 系统管理--状态码管理
      9014: <TMaterialsTypeManage onAdd={addTab} />, // 系统管理--物料配置
      9034: <TenceCompanyM onAdd={addTab} />, // 系统管理--设备供应商管理
      9035: <CityTypeCrud onAdd={addTab} />, // 城市类别设置
      9036: <EndCodeStatus onAdd={addTab} />, // 停止原因设置
      9017: <UseManagement onAdd={addTab} />, // 系统管理--用途管理
      9018: <DownloadCenter onAdd={addTab} />, // 系统管理--下载中心
      9005: <FirmwareVersion onAdd={addTab} />, // 系统管理--固件版本管理
      "0701": <DiagnosticAnalysis onAdd={addTab} />,
      errorCodeConfig: <ErrorCodeConfig onAdd={addTab} onDelete={remove} />, // 状态码配置
      tMaterialsTypeConfig: <TMaterialsTypeConfig onAdd={addTab} onDelete={remove} />, // 物料配置--编辑
      firmwareVersionList: <FirmwareVersionList onAdd={addTab} />, // 系统管理--固件版本管理--详情
      moduleDetail: <ModuleDetail onAdd={addTab} />, // 配置管理--模块管理--历史设备
      moduleInfo: <ModuleInfo onAdd={addTab} />, // 配置管理--设备快速查询--模块信息
      chargeCourse: <ChargeCourse onAdd={addTab} />, // 配置管理--设备快速查询--订单信息--充电数据；在线运维--订单列表/非直连订单--充电数据
      powerCourse: <PowerCourse onAdd={addTab} />, // 配置管理--设备快速查询--订单信息--模块数据；在线运维--订单列表--模块数据
      stubStationIntact: <StubStationIntact onAdd={addTab} />, // 报表管理--设备指标报表--设备完好率-电站完好率趋势
      stubIntactDetail: <StubIntactDetail onAdd={addTab} />, // 报表管理--设备指标报表--设备完好率--设备完好率趋势
      monitoringDetail: <MonitoringDetail onAdd={addTab} />, // 事件监控详情
      equChargeSuccessDetail: <EquChargeDetail onAdd={addTab} />, // 设备充电成功率
      stationChargeSuccessDetail: <StationChargeDetail onAdd={addTab} />, // 电站充电成功率
      // 1.6.2
      stubBasicInfo: <StubBasicInfo onAdd={addTab} />, // 设备基础信息
      stubGroupBasicInfo: <StubGroupBasicInfo onAdd={addTab} />, // 电站基础信息
      taskBuildStep: <TaskBuildStep onAdd={addTab} />, // 创建任务
      // 1.70
      stubGroupTobu: <StubGroupTobu onAdd={addTab} />,
      // 1.8.0
      activeKey: {
        isMicroApp: true, // 是否为子应用
        ...bindAppParams("omc", "activeKey"), // 子应用名称和要进入的子应用的页面id
      }, // 子应用tab项示例

      // 工单管理--报告管理
      9102: { isMicroApp: true, ...bindAppParams("omc", "9102") },
      // 工单管理--工单列表
      9103: { isMicroApp: true, ...bindAppParams("omc", "9103") },
      // 工单管理--创建工单
      "9103create": { isMicroApp: true, ...bindAppParams("omc", "9103create") },
      // 工单管理--编辑工单
      "9103edit": { isMicroApp: true, ...bindAppParams("omc", "9103edit") },
      // 工单管理--工单详情
      "9103read": { isMicroApp: true, ...bindAppParams("omc", "9103read") },
      // 工单详情--最近工单tab--详情跳转页面
      "9104read": { isMicroApp: true, ...bindAppParams("omc", "9104read") },
      // 工单管理--墙盒工单--工单列表
      9113: { isMicroApp: true, ...bindAppParams("omc", "9113") },
      // 工单管理--墙盒工单--创建工单
      "9113create": { isMicroApp: true, ...bindAppParams("omc", "9113create") },
      // 工单管理--墙盒工单--创建工单
      "9113edit": { isMicroApp: true, ...bindAppParams("omc", "9113edit") },
      // 工单管理--墙盒工单--工单详情
      "9113read": { isMicroApp: true, ...bindAppParams("omc", "9113read") },
      // 工单管理--报价单列表(原付费维修)
      9101: {
        isMicroApp: true,
        ...bindAppParams("omc", "9101"),
      },
      "9101list": {
        isMicroApp: true,
        ...bindAppParams("omc", "9101list"),
      },
      // 工单管理--客服服务单
      9104: { isMicroApp: true, ...bindAppParams("omc", "9104") },
      // 工单管理--创建服务单
      910403: { isMicroApp: true, ...bindAppParams("omc", "910403") },
      // 工单管理--编辑服务单
      910402: { isMicroApp: true, ...bindAppParams("omc", "910402") },
      "20210706password": { isMicroApp: true, ...bindAppParams("omc", "20210706password") },
      // 工单管理--服务单详情
      910404: { isMicroApp: true, ...bindAppParams("omc", "910404") },
      // 工单管理--创建销售服务单
      913303: { isMicroApp: true, ...bindAppParams("omc", "913303") },
      // 工单管理--销售服务单
      9133: { isMicroApp: true, ...bindAppParams("omc", "9133") },
      // 工单管理--编辑销售服务单(-)
      913302: { isMicroApp: true, ...bindAppParams("omc", "913302") },
      // 工单管理--销售服务单详情
      913304: { isMicroApp: true, ...bindAppParams("omc", "913304") },
      // 工单管理--报价单--报价单列表(旧)
      // 9105: { isMicroApp: true, ...bindAppParams("omc", "9105") },
      // 工单管理--报价单--报价单创建(旧)
      // 910502: { isMicroApp: true, ...bindAppParams("omc", "910502") },
      // 工单管理--报价单--报价单详情(旧)
      // 910501: { isMicroApp: true, ...bindAppParams("omc", "910501") },
      // 系统管理--工单配置--类别配置
      9106: { isMicroApp: true, ...bindAppParams("omc", "9106") },
      // 系统管理--工单配置--费用项配置
      9107: { isMicroApp: true, ...bindAppParams("omc", "9107") },
      // 工单管理--检查组管理--检查组列表
      9108: { isMicroApp: true, ...bindAppParams("omc", "9108") },
      // 工单管理--检查组管理--检查组新建
      "9108create": { isMicroApp: true, ...bindAppParams("omc", "9108create") },
      // 工单管理--检查组管理--检查组编辑
      "9108edit": { isMicroApp: true, ...bindAppParams("omc", "9108edit") },
      // 工单管理--检查项管理
      9109: { isMicroApp: true, ...bindAppParams("omc", "9109") },
      // 工单管理--检查项管理--新建检查项
      "9109create": { isMicroApp: true, ...bindAppParams("omc", "9109create") },
      // 工单管理--检查项管理--编辑检查项
      "9109edit": { isMicroApp: true, ...bindAppParams("omc", "9109edit") },
      // 工单管理--检查项管理--目录管理
      "9109add": { isMicroApp: true, ...bindAppParams("omc", "9109add") },
      // 工单管理--计划配置管理
      9110: { isMicroApp: true, ...bindAppParams("omc", "9110") },
      // "9110management": { isMicroApp: true, ...bindAppParams("omc", "9110") },
      // 系统管理--巡检计划配置--配置计划
      911001: { isMicroApp: true, ...bindAppParams("omc", "911001") },
      // 系统管理--用户管理
      9001: { isMicroApp: true, ...bindAppParams("omc", "9001") },
      // 系统管理--企业账户管理--企业配置
      9008: { isMicroApp: true, ...bindAppParams("omc", "9008") },
      // 系统管理--角色列表
      9003: { isMicroApp: true, ...bindAppParams("omc", "9003") },
      // 系统管理--区域管理--区域列表
      9009: { isMicroApp: true, ...bindAppParams("omc", "9009") },
      // 系统管理--工作组管理
      9010: { isMicroApp: true, ...bindAppParams("omc", "9010") },
      // 系统管理--派单规则
      9011: { isMicroApp: true, ...bindAppParams("omc", "9011") },
      "9011manegement": { isMicroApp: true, ...bindAppParams("omc", "9011manegement") },
      // 系统管理--服务商配置
      9037: { isMicroApp: true, ...bindAppParams("omc", "9037") },
      // 仓库管理--仓库列表
      "0801": { isMicroApp: true, ...bindAppParams("omc", "0801") },
      // 仓库管理--库存列表
      "0802": { isMicroApp: true, ...bindAppParams("omc", "0802") },
      "0802allocation": { isMicroApp: true, ...bindAppParams("omc", "0802allocation") },
      // 仓库管理--坏件管理
      "0803": { isMicroApp: true, ...bindAppParams("omc", "0803") },
      // 仓库管理--物料审批调拨
      "0804": { isMicroApp: true, ...bindAppParams("omc", "0804") },
      // 仓库管理--回收物料
      "0805": { isMicroApp: true, ...bindAppParams("omc", "0805") },
      // 仓库管理--调拨列表
      "0806": { isMicroApp: true, ...bindAppParams("omc", "0806") },
      "0806detail": { isMicroApp: true, ...bindAppParams("omc", "0806detail") },
      // 仓库管理--新增物料审批调拨
      "0507create": {
        isMicroApp: true,
        ...bindAppParams("omc", "0507create"),
      },
      // 仓库管理--物料审批调拨编辑
      "0507editSingle": {
        isMicroApp: true,
        ...bindAppParams("omc", "0507editSingle"),
      },
      // 仓库管理--物料审批调拨详情
      "0507detail": {
        isMicroApp: true,
        ...bindAppParams("omc", "0507detail"),
      },
      // 设备列表
      "0006200100": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200100"),
      },
      // 配置修改
      "10stubParamsConfig": {
        isMicroApp: true,
        ...bindAppParams("omc", "10stubParamsConfig"),
      },
      // 变更记录
      "10modifyLog": {
        isMicroApp: true,
        ...bindAppParams("omc", "10modifyLog"),
      },
      // 诊断报告
      "10zdbg": {
        isMicroApp: true,
        ...bindAppParams("omc", "10zdbg"),
      },
      // 诊断管理--知识库
      9111: {
        isMicroApp: true,
        ...bindAppParams("omc", "9111"),
      },
      // 诊断管理--方案详情
      kn0002: {
        isMicroApp: true,
        ...bindAppParams("omc", "kn0002"),
      },
      // 诊断管理--新建方案
      kn0003: {
        isMicroApp: true,
        ...bindAppParams("omc", "kn0003"),
      },
      // 系统管理--工单配置--工单评价
      900703: {
        isMicroApp: true,
        ...bindAppParams("omc", "900703"),
      },
      // "0006200400": {
      //   isMicroApp: true,
      //   ...bindAppParams("omc", "0006200400"),
      // },
      // 批量任务管理
      "0006200300": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200300"),
      },
      // 新建批量配置修改任务
      "0006200301": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200301"),
      },
      // 新建批量固件升级任务
      "0006200302": {
        isMicroApp: true,
        ...bindAppParams("omc", "0006200302"),
      },
      // 在线运维--设备操作日志
      "0508": {
        isMicroApp: true,
        ...bindAppParams("omc", "0508"),
      },
      // 在线运维--任务管理
      "0503": {
        isMicroApp: true,
        ...bindAppParams("omc", "0503"),
      },
      // 在线运维--任务管理-配置修改
      "050301": {
        isMicroApp: true,
        ...bindAppParams("omc", "050301"),
      },
      // 在线运维--任务管理-固件升级
      "050302": {
        isMicroApp: true,
        ...bindAppParams("omc", "050302"),
      },
      // 在线运维--任务管理-批量故障工单
      "050303": {
        isMicroApp: true,
        ...bindAppParams("omc", "050303"),
      },
      // 在线运维--任务管理-批量通用工单
      "050304": {
        isMicroApp: true,
        ...bindAppParams("omc", "050304"),
      },
      // 批量任务管理--执行情况
      "050305": {
        isMicroApp: true,
        ...bindAppParams("omc", "050305"),
      },
      // 工单管理--任务管理-重新执行工单
      "050306": {
        isMicroApp: true,
        ...bindAppParams("omc", "050306"),
      },
      // 系统管理--工作项配置--新建企业
      "20210712createcompany": {
        isMicroApp: true,
        ...bindAppParams("omc", "20210712createcompany"),
      },
      // 基础数据录入--电站录入
      900601: { isMicroApp: true, ...bindAppParams("omc", "900601") },
      "900601edit": { isMicroApp: true, ...bindAppParams("omc", "900601edit") },
      // 基础数据录入--设备录入--设备列表
      900602: { isMicroApp: true, ...bindAppParams("omc", "900602") },
      // 基础数据录入--设备录入--新增设备
      "900602create": { isMicroApp: true, ...bindAppParams("omc", "900602create") },
      // 基础数据录入--设备录入--编辑设备
      "900602edit": { isMicroApp: true, ...bindAppParams("omc", "900602edit") },
      // 基础数据录入--设备录入--查看设备
      "900602read": { isMicroApp: true, ...bindAppParams("omc", "900602read") },
      "900602bomList": { isMicroApp: true, ...bindAppParams("omc", "900602bomList") },
      // 系统管理--工单配置--超时配置
      9112: { isMicroApp: true, ...bindAppParams("omc", "9112") },
      // 工作台
      "02": { isMicroApp: true, ...bindAppParams("omc", "02") },
    };
    return Frame;
  }
}

export default Tabs;



// WEBPACK FOOTER //
// ./src/AntD/tabs/tabs.js